var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initPage)?_c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"loading"})]):_c('div',[_c('Packs',{attrs:{"type":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }